const MerchantTokenInfoApp = ({ users }) => {
  if (!users || users.length === 0) {
    return (
      <div style={{ padding: 20 }}>
        <h2>No users found for the provided merchant token.</h2>
      </div>
    );
  }

  const merchantToken =
    users[0].merchant_token || users[0].legacy_user_model_token;

  const renderOrders = (orders) => {
    return (
      <ol>
        {orders.map((order, index) => {
          const {
            number: orderNumber,
            type: orderType,
            state: orderState,
          } = order;

          return (
            <li key={index}>
              <div>
                Order Number:{' '}
                <a
                  href={`/admin/health/order/${orderNumber}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {orderNumber}
                </a>
              </div>
              <div>Order State: {orderState}</div>
              <div>Order Type: {orderType}</div>
            </li>
          );
        })}
      </ol>
    );
  };

  const renderUsers = () => {
    return (
      <ol>
        {users.map((user, index) => {
          const {
            id: userId,
            person_token: personToken,
            legacy_user_model_token: legacyUserModelToken,
            merchant_token: merchantToken,
            employment_token: employmentToken,
            orders,
          } = user;

          return (
            <li key={index}>
              <div>User ID: {userId}</div>
              <div>Person Token: {personToken}</div>
              <div>Legacy User Model Token: {legacyUserModelToken}</div>
              <div>Merchant Token: {merchantToken}</div>
              <div>Employment Token: {employmentToken}</div>
              <strong>Orders:</strong>
              <div>{renderOrders(orders)}</div>
            </li>
          );
        })}
      </ol>
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ margin: 0 }}>Information for {merchantToken}</h2>
      <h5 style={{ marginTop: 10, marginBottom: 10 }}>
        <a
          href={`https://regulator.sqprod.co/n/merchants/${merchantToken}`}
          target="_blank"
          rel="noreferrer"
        >
          Regulator
        </a>
      </h5>
      <h5 style={{ marginTop: 20, marginBottom: 10 }}>Users</h5>
      <div>{renderUsers()}</div>
    </div>
  );
};

export default MerchantTokenInfoApp;
